import { Component, OnInit } from '@angular/core';
import { FeatureFlagService } from '../../../../../shared/services/feature-flag.service';
import { Answer } from '../../../../applicant-service/service-models/Answer';
import { Choice } from '../../../../job-service/service-models/Choice';
import { YesNoQuestion } from '../../../../job-service/service-models/YesNoQuestion';
import { QuestionComponent } from '../question-component';

@Component({
  selector: 'app-yes-no',
  templateUrl: './yes-no.component.html',
  styleUrls: ['./yes-no.component.scss']
})
export class YesNoComponent extends QuestionComponent<YesNoQuestion> implements OnInit {
  downloadRoute: string;
  
  constructor() {
    super();
  }

  ngOnInit() {
    this.question = this.question || new YesNoQuestion();

    if (this.question.answers === undefined) {
      this.question.answers = [new Answer()];
    }

    this.downloadRoute = `jobs/${this.jobId}/elements/${this.element.id}/questions/${this.question.id}/attachments`;
  }

  onChoiceChange(choice: Choice) {
    this.question.answers[0].choiceId = choice.id;
    this.question.answers[0].questionId = this.question.id;
    this.question.answers[0].value = choice.value;
    this.question.answers[0].questionVersion = this.question.version;

    this.questionAnswered();
  }
}
